import "./ClientMedicalProviderInformationFormComponent.scss";
import {IClientMedicalProviderForm} from "../../../../shared/models/client.model";
import React, {useCallback, useEffect, useState} from "react";
import _ from "lodash";
import {Field, FieldProps, Form, Formik, FormikHelpers} from "formik";
import {CommonService} from "../../../../shared/services";
import {IAPIResponseType} from "../../../../shared/models/api.model";
import {ImageConfig, Misc} from "../../../../constants";
import FormControlLabelComponent from "../../../../shared/components/form-control-label/FormControlLabelComponent";
import CardComponent from "../../../../shared/components/card/CardComponent";
import ButtonComponent from "../../../../shared/components/button/ButtonComponent";
import FormikInputComponent from "../../../../shared/components/form-controls/formik-input/FormikInputComponent";
import FormikDatePickerComponent
    from "../../../../shared/components/form-controls/formik-date-picker/FormikDatePickerComponent";
import {useDispatch} from "react-redux";
import LoaderComponent from "../../../../shared/components/loader/LoaderComponent";
import StatusCardComponent from "../../../../shared/components/status-card/StatusCardComponent";
import HeadingWithNavigationComponent
    from "../../../../shared/components/heading-with-navigation/HeadingWithNavigationComponent";
import IconButtonComponent from "../../../../shared/components/icon-button/IconButtonComponent";
import ToolTipComponent from "../../../../shared/components/tool-tip/ToolTipComponent";
import FormikPhoneInputComponent from "../../../../shared/components/formik-phone-input/FormikPhoneInputComponent";
import moment from "moment";
import DetailsViewCardComponent from "../../../../shared/components/details-view-card/DetailsViewCardComponent";
import AcknowledgementFormComponent from "../../acknowledgement-form/AcknowledmentFormComponent";
import ModalComponent from "../../../../shared/components/modal/ModalComponent";

interface ClientMedicalProviderInformationFormComponentProps {
    onCancel: () => void;
    onNext: () => void;
    clientId: string;
    onSave: (clientMedicalProviderInformationDetails: any) => void;
    clientMedicalHistoryDetails: any
    isClientMedicalHistoryDetailsLoaded: boolean | undefined;
    isClientMedicalHistoryDetailsLoading: boolean | undefined;
    isClientMedicalHistoryDetailsLoadingFailed: boolean | undefined;
}

const ClientMedicalProviderInformationInitialValues: IClientMedicalProviderForm = {
    medical_provider_info: {
        family_doctor_name: "",
        referring_doctor_name: "",
        md_phone: "",
        primary_phone: "",
        last_examination_date: "",
    }
};

const ClientMedicalProviderInformationFormComponent = (props: ClientMedicalProviderInformationFormComponentProps) => {

    const {
        onCancel, onSave,
        clientId,
        clientMedicalHistoryDetails,
        isClientMedicalHistoryDetailsLoaded,
        isClientMedicalHistoryDetailsLoading,
        isClientMedicalHistoryDetailsLoadingFailed
    } = props;
    const [clientMedicalProviderInformationInitialValues, setClientMedicalProviderInformationInitialValues] = useState<IClientMedicalProviderForm>(_.cloneDeep(ClientMedicalProviderInformationInitialValues));
    const [isClientMedicalProviderInformationSavingInProgress, setIsClientMedicalProviderInformationSavingInProgress] = useState(false);
    const dispatch = useDispatch();

    const [isAcknowledgementModalOpen, setIsAcknowledgementModalOpen] = useState(false);

    const onSubmit = useCallback((values: any, {setErrors}: FormikHelpers<any>) => {
        setClientMedicalProviderInformationInitialValues(values);
        setIsAcknowledgementModalOpen(true);
    }, [])

    const handleAcknowledgementFormSubmit = useCallback((acknowledgementValues: any) => {
        const payload = {
            ...acknowledgementValues,
            ...clientMedicalProviderInformationInitialValues,
            client_id: clientId
        };
        setIsClientMedicalProviderInformationSavingInProgress(true);
        CommonService._client.ClientMedicalProviderInfoDetailsSaveAPICall(payload)
            .then((response: IAPIResponseType<IClientMedicalProviderForm>) => {
                CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY], "success");
                setIsClientMedicalProviderInformationSavingInProgress(false);
                setClientMedicalProviderInformationInitialValues(_.cloneDeep(acknowledgementValues));
                onSave(response);
            })
            .catch((error: any) => {
                CommonService._alert.showToast(error[Misc.API_RESPONSE_MESSAGE_KEY], 'error');
                setIsClientMedicalProviderInformationSavingInProgress(false);
            })
    }, [onSave,clientId,clientMedicalProviderInformationInitialValues]);

    useEffect(() => {
        if (clientMedicalHistoryDetails) {
            setClientMedicalProviderInformationInitialValues({
                medical_provider_info: clientMedicalHistoryDetails.medical_provider_info
            });
        }
    }, [dispatch, clientMedicalHistoryDetails]);

    return (
        <div className={'client-medical-provider-information-form-component'}>
            <>
                {
                    isClientMedicalHistoryDetailsLoading && <div>
                        <LoaderComponent/>
                    </div>
                }
                {
                    isClientMedicalHistoryDetailsLoadingFailed &&
                    <StatusCardComponent title={"Failed to fetch medical Details"}/>
                }
            </>
            {
                isClientMedicalHistoryDetailsLoaded && <>
                    <HeadingWithNavigationComponent onBackNavigation={onCancel}
                                                    title={"Back"}/>
                    <Formik
                        initialValues={clientMedicalProviderInformationInitialValues}
                        onSubmit={onSubmit}
                        validateOnChange={false}
                        validateOnBlur={true}
                        enableReinitialize={true}
                        validateOnMount={true}>
                        {({values, isValid, validateForm, dirty}) => {
                            // eslint-disable-next-line react-hooks/rules-of-hooks
                            useEffect(() => {
                                validateForm();
                            }, [validateForm, values]);
                            return (<CardComponent>
                                    <div className={'edit-medical-provider-heading'}>
                                        Edit Medical Provider Information
                                    </div>
                                    <Form noValidate={true} className={"t-form"}>
                                        <div className={'medical-provider-wrapper'}>
                                            <DetailsViewCardComponent title={"Medical Provider Information"}>

                                                <FormControlLabelComponent label={"Family Doctor"}/>
                                                <div className="ts-row">
                                                    <div className="ts-col">
                                                        <Field name={`medical_provider_info.family_doctor_name`}>
                                                            {
                                                                (field: FieldProps) => (
                                                                    <FormikInputComponent
                                                                        label={"Full Name"}
                                                                        placeholder={"Full Name"}
                                                                        formikField={field}
                                                                        fullWidth={true}
                                                                    />
                                                                )
                                                            }
                                                        </Field>
                                                    </div>
                                                    <div className="ts-col">
                                                        <Field name={`medical_provider_info.md_phone`}>
                                                            {
                                                                (field: FieldProps) => (
                                                                    <FormikPhoneInputComponent
                                                                        label={'MD Phone'}
                                                                        placeholder={'Enter MD Phone'}
                                                                        formikField={field}
                                                                        fullWidth={true}
                                                                    />
                                                                )
                                                            }
                                                        </Field>
                                                    </div>
                                                    <div className="ts-col-1 d-flex align-items-center">
                                                        <IconButtonComponent className={"form-helper-icon"}>
                                                            <ToolTipComponent
                                                                showArrow={true}
                                                                position={"left"}
                                                                tooltip={"This phone number will be used to communicate with your family doctor, if required. Please ensure that this number is valid and operational."}>
                                                                <ImageConfig.InfoIcon/>
                                                            </ToolTipComponent>
                                                        </IconButtonComponent>
                                                    </div>
                                                </div>
                                                <FormControlLabelComponent label={"Referring Doctor"}/>
                                                <div className="ts-row">
                                                    <div className="ts-col">
                                                        <Field name={`medical_provider_info.referring_doctor_name`}>
                                                            {
                                                                (field: FieldProps) => (
                                                                    <FormikInputComponent
                                                                        label={"Full Name"}
                                                                        placeholder={"Full Name"}
                                                                        formikField={field}
                                                                        fullWidth={true}
                                                                    />
                                                                )
                                                            }
                                                        </Field>
                                                    </div>
                                                    <div className="ts-col">
                                                        <Field name={`medical_provider_info.primary_phone`}>
                                                            {
                                                                (field: FieldProps) => (
                                                                    <FormikPhoneInputComponent
                                                                        label={'MD Phone'}
                                                                        placeholder={'Enter MD Phone'}
                                                                        formikField={field}
                                                                        fullWidth={true}
                                                                    />
                                                                )
                                                            }
                                                        </Field>
                                                    </div>
                                                    <div className="ts-col-1 d-flex align-items-center">
                                                        <IconButtonComponent className={"form-helper-icon"}>
                                                            <ToolTipComponent
                                                                showArrow={true}
                                                                position={"left"}
                                                                tooltip={"This phone number will be used to communicate with your referring doctor regarding your case. Please ensure that this number is valid and operational."}>
                                                                <ImageConfig.InfoIcon/>
                                                            </ToolTipComponent>
                                                        </IconButtonComponent>
                                                    </div>
                                                </div>
                                                <FormControlLabelComponent label={"Date of Last Physical Examination"}/>
                                                <div className="ts-row">
                                                    <div className="ts-col">
                                                        <Field name={`medical_provider_info.last_examination_date`}>
                                                            {
                                                                (field: FieldProps) => (
                                                                    <FormikDatePickerComponent
                                                                        label={"Date"}
                                                                        placeholder={"Select Date"}
                                                                        maxDate={moment()}
                                                                        formikField={field}
                                                                        fullWidth={true}
                                                                    />
                                                                )
                                                            }
                                                        </Field>
                                                    </div>
                                                    <div className="ts-col"/>
                                                    <div className="ts-col-1"/>

                                                </div>
                                            </DetailsViewCardComponent>
                                        </div>


                                        <div className="t-form-actions mrg-bottom-0">
                                            <ButtonComponent
                                                id={"home_btn"}
                                                variant={"outlined"}
                                                onClick={onCancel}
                                                disabled={isClientMedicalProviderInformationSavingInProgress}
                                                color={'accent'}
                                            >
                                                Cancel
                                            </ButtonComponent>&nbsp;
                                            <ButtonComponent
                                                id={"save_next_btn"}
                                                className={'mrg-left-25'}
                                                isLoading={isClientMedicalProviderInformationSavingInProgress}
                                                disabled={isClientMedicalProviderInformationSavingInProgress}
                                                type={"submit"}
                                                color={'accent'}
                                            >
                                                {/*{isClientMedicalProviderInformationSavingInProgress ? "Saving" : "Save"}*/}
                                                Next
                                            </ButtonComponent>
                                        </div>


                                    </Form>

                                </CardComponent>
                            )
                        }}
                    </Formik>
                </>
            }
            <ModalComponent isOpen={isAcknowledgementModalOpen}>
                <AcknowledgementFormComponent setIsAcknowledgementModalOpen={setIsAcknowledgementModalOpen}
                                              isLoading={isClientMedicalProviderInformationSavingInProgress}
                                              onSubmit={handleAcknowledgementFormSubmit}/>
            </ModalComponent>
        </div>
    );

};

export default ClientMedicalProviderInformationFormComponent;
